/* Stock template only. Sort the complete filtered result before taking a page,
   rather than moving sold-out cards only within each server-rendered page. */
(() => {
  if (customElements.get('almond-stock-order')) return;
  class AlmondStockOrder extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.started) return;
        this.started = true;
        this.querySelector('button').onclick = () => this.sort();
        this.sort();
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.started = false; }
    async sort() {
      this.controller?.abort();
      const controller = new AbortController(); this.controller = controller;
      const section = this.closest('[data-section-type="collection-template"]');
      const grid = section.querySelector('[data-product-container]');
      if (!grid) return;
      const status = this.querySelector('[role="status"]');
      const retry = this.querySelector('button'); retry.hidden = true;
      const page = Number(this.dataset.page), pages = Number(this.dataset.pages), size = Number(this.dataset.size);
      const original = [...grid.querySelectorAll('[data-stock-id]')];
      grid.setAttribute('aria-busy','true');
      status.textContent = 'Sorting boards…';
      const timer = setTimeout(() => controller.abort(), 30000);
      try {
        const cards = new Map(original.map(node => [node.dataset.stockId, node]));
        const base = new URL(location.href);
        base.searchParams.delete('sections');
        base.searchParams.set('section_id',this.dataset.section);
        // Retain filters, tag path, sort and market parameters so each request
        // uses the same server pagination boundaries as the original response.
        const pending = Array.from({length:pages},(_,i)=>i+1).filter(n=>n!==page);
        await Promise.all(Array.from({length:Math.min(3,pending.length)},async()=>{
          while(pending.length) {
            const number = pending.shift();
            const url = new URL(base); url.searchParams.set('page',number);
            const response = await fetch(url,{signal:controller.signal,credentials:'same-origin'});
            if (!response.ok) throw new Error('Could not load all boards');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const marker = doc.querySelector('almond-stock-order');
            if (!marker || Number(marker.dataset.page)!==number || Number(marker.dataset.total)!==Number(this.dataset.total)) throw new Error('Collection changed');
            doc.querySelectorAll('[data-stock-id]').forEach(node=>cards.set(node.dataset.stockId,node));
          }
        }));
        if (cards.size !== Number(this.dataset.total)) throw new Error('Incomplete collection');
        const priority = node => node.dataset.stockNew === 'true' ? 0 : node.dataset.stockAvailable === 'true' ? 1 : 2;
        const ordered = [...cards.values()].sort((a,b)=>
          priority(a) - priority(b) ||
          Number(b.dataset.stockCreated) - Number(a.dataset.stockCreated) ||
          a.dataset.stockId.localeCompare(b.dataset.stockId)
        );
        if (!this.isConnected || controller.signal.aborted) return;
        grid.replaceChildren(...ordered.slice((page-1)*size,page*size));
        window.MinimogTheme?.Collection?.initProducts();
        window.MinimogEvents?.emit('ON_PRODUCT_LIST_UPDATED');
        status.textContent = '';
      } catch(error) {
        if (!this.isConnected) return;
        status.textContent = 'Couldn’t sort all boards. Please retry.';
        retry.hidden = false;
      } finally {
        clearTimeout(timer);
        if (this.controller === controller) grid.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('almond-stock-order',AlmondStockOrder);
})();
